import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import StackView from '../StackView';
import { useThemeValue } from '../system';

function PageToolbar(_ref) {
  var _mediaQueries;

  var stackBelow = _ref.stackBelow,
      restProps = _objectWithoutPropertiesLoose(_ref, ["stackBelow"]);

  var themeBreakpoints = useThemeValue('breakpoints');
  var breakpoint = Object.keys(themeBreakpoints).includes(stackBelow) ? stackBelow : 'sm';
  var stackProps = stackBelow ? {
    axis: 'vertical',
    alignment: 'stretch',
    spacing: 2,
    mediaQueries: (_mediaQueries = {}, _mediaQueries[breakpoint] = {
      axis: 'horizontal',
      alignment: 'center',
      paddingBottom: 0,
      spacing: 0
    }, _mediaQueries)
  } : null;
  return /*#__PURE__*/React.createElement(StackView, _extends({
    alignment: "center",
    axis: "horizontal",
    distribution: "space-between",
    flex: 1,
    spacing: 2,
    width: "100%"
  }, stackProps, restProps));
}

export default PageToolbar;